// extracted by mini-css-extract-plugin
export default {"wrapper":"MobileItemsList_wrapper__ynyz7","empty":"MobileItemsList_empty__1m6Lu"};